/* Chery Style – bezorgbelofte, BLACK FRIDAY 2026-versie (alleen in het thema "Chery Style – Black Friday 2026").
   Vanwege de drukte rond Black Friday geen klok en geen "morgen in huis", maar overal een vaste levertijd van 2–3 werkdagen.
   Vult: het mandje (.free-shipping--cutoff en data-cs-delivery="cart") met de mandje-tekst incl. reden,
   en de productpagina (data-cs-delivery "pdp", "box-title", "box-sub").
   Pre-orders (data-preorder="true"): geen tekst.
   1 nov 2026: Mix & Match is niet van toepassing tijdens Black Friday; de MIX & MATCH-badge op productkaarten
   (collecties, ook na filteren) wordt hier verborgen, en de kortingsbadge op die kaarten krijgt dezelfde
   rode opmaak en plek (linksboven) als op alle andere kaarten (was groen, klein, rechts).
   Terug naar de gewone situatie = het gewone thema weer publiceren. */
(function () {
  try {
    var st = document.createElement('style');
    st.textContent = '.cs-mm-card-badge,.cs-mm-title-badge,cs-mm-recommendations,.cs-mm-offer{display:none!important}'
      + '.cs-mm-card-badges{display:flex!important;flex-wrap:wrap;align-items:flex-start;gap:4px 6px!important;top:8px!important;left:8px!important;right:8px!important}'
      + '.cs-mm-card-badges .badge.onsale{background:#c62a32!important;color:#fff!important;font-size:14px!important;line-height:18.2px!important;padding:3px 10px!important;border-radius:999px!important;margin:0!important;justify-self:start!important;align-self:flex-start!important}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  var T = {
    nl: { cart: 'Levertijd <strong>2–3 werkdagen</strong> door de extreme Black Friday-drukte', line: 'Binnen <strong>2–3 werkdagen</strong> in huis', title: 'Binnen 2–3 werkdagen in huis', sub: 'Door de Black Friday-drukte duurt de levering iets langer' },
    en: { cart: 'Delivery time <strong>2–3 working days</strong> due to the huge Black Friday rush', line: 'Delivered in <strong>2–3 working days</strong>', title: 'Delivered in 2–3 working days', sub: 'Delivery takes a little longer due to the Black Friday rush' },
    de: { cart: 'Lieferzeit <strong>2–3 Werktage</strong> wegen des enormen Black-Friday-Andrangs', line: 'Lieferung in <strong>2–3 Werktagen</strong>', title: 'Lieferung in 2–3 Werktagen', sub: 'Wegen des Black-Friday-Andrangs dauert die Lieferung etwas länger' },
    fr: { cart: 'Délai de livraison <strong>2 à 3 jours ouvrés</strong> en raison de la forte affluence du Black Friday', line: 'Livré en <strong>2 à 3 jours ouvrés</strong>', title: 'Livré en 2 à 3 jours ouvrés', sub: 'La livraison prend un peu plus de temps en raison du Black Friday' },
    pl: { cart: 'Czas dostawy <strong>2–3 dni robocze</strong> z powodu ogromnej liczby zamówień w Black Friday', line: 'Dostawa w ciągu <strong>2–3 dni roboczych</strong>', title: 'Dostawa w ciągu 2–3 dni roboczych', sub: 'Z powodu Black Friday dostawa trwa nieco dłużej' }
  };
  var SELECTOR = 'free-shipping .free-shipping--cutoff, .et-free-shipping-countdown .free-shipping--cutoff, [data-cs-delivery]';

  function lang() { var l = ((document.documentElement.lang || 'nl').split('-')[0] || 'nl').toLowerCase(); return T[l] ? l : 'en'; }

  function update() {
    var t = T[lang()];
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (el) {
      if (el.getAttribute('data-preorder') === 'true') {
        el.innerHTML = '';
        el.style.display = 'none';
        var wrap = el.closest('.et-free-shipping-countdown');
        if (wrap) wrap.style.display = 'none';
        return;
      }
      var attr = el.getAttribute('data-cs-delivery');
      var html;
      if (attr === 'box-title') html = t.title;
      else if (attr === 'box-sub') html = t.sub;
      else if (attr === 'pdp') html = t.line;
      else html = t.cart;
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  function soon() { update(); setTimeout(update, 400); setTimeout(update, 1500); }
  ['cart-drawer:open', 'cart:item-added', 'line-item:change:end', 'cart:refresh', 'cart:updated'].forEach(function (n) { document.addEventListener(n, soon); });
  window.csDelivery = { update: update, state: function () { return { countdown: false, busy: true }; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
})();
